import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AdBlockWarning from "./AdBlockWarning";
import { detectAdBlock } from "../../utils/detectAdBlock";
import { loadAdSenseOnce } from "../../utils/loadAdSenseOnce";

const EXCLUDED_ROUTES = [
    "/login",
    "/register",
    "/adblock-warning",
    "/impressum",
    "/nutzungsbestimmungen",
    "/datenschutz",
];

// Rollen, die KEINE Auto Ads sehen sollen
const NO_AD_ROLES = [1, 2, 3, 4]; // Admin, Redakteur, Moderator, Abonnent

function normalizePath(loc) {
    const raw = loc.hash?.replace(/^#/, "") || loc.pathname || "/";
    return raw.split("?")[0].replace(/\/+$/, "") || "/";
}

const AdBlockChecker = ({
    children,
    clientId = "ca-pub-3219202769714805", // Deine AdSense Publisher ID
    enableAutoAds = true,
    requireConsent = false,
    hasConsent = false,
}) => {
    const location = useLocation();
    const { user } = useAuth();

    const [adBlockDetected, setAdBlockDetected] = useState(false);
    const [checked, setChecked] = useState(false);

    const currentPath = useMemo(() => normalizePath(location), [location]);

    // 1) Adblock prüfen
    useEffect(() => {
        let mounted = true;
        detectAdBlock().then((detected) => {
            if (!mounted) return;
            setAdBlockDetected(detected);
            setChecked(true);
        });
        return () => { mounted = false; };
    }, []);

    // 2) Auto Ads laden, wenn erlaubt
    useEffect(() => {
        if (!enableAutoAds) return;
        if (!checked) return;

        const isExcluded = EXCLUDED_ROUTES.includes(currentPath);
        const roleBlocked = user && NO_AD_ROLES.includes(user.role_id);

        if (roleBlocked) return;        // Rollen 1–4: keine Ads
        if (isExcluded) return;         // Bestimmte Seiten: keine Ads
        if (adBlockDetected) return;    // Adblock: keine Ads
        if (requireConsent && !hasConsent) return; // Kein Consent: keine Ads

        loadAdSenseOnce(clientId);      // lädt Script nur einmal
    }, [
        enableAutoAds,
        checked,
        currentPath,
        user,
        adBlockDetected,
        requireConsent,
        hasConsent,
        clientId,
    ]);

    // 3) Rendering-Guard
    if (!checked) return null; // warten bis Adblock-Check fertig

    const roleBlocked = user && NO_AD_ROLES.includes(user.role_id);
    const isExcluded = EXCLUDED_ROUTES.includes(currentPath);

    if (roleBlocked || isExcluded) {
        return children;
    }

    // Wenn Mitglied (role 5) & Adblock aktiv → Warnseite
    if (!roleBlocked && adBlockDetected) {
        return <AdBlockWarning previousPath={currentPath} />;
    }
    
    return children;
};

export default AdBlockChecker;